<template lang="pug">
section
  s-page-title(title='Новости')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
        template(slot='controls')
          v-layout
            v-flex(xs12)
              s-sites-picker(
                :value='dataFilter.site_id'
                :returnObject='false'
                @change='setSiteId'
                label='Выберите сайт'
              )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.published_at }}
          td 
            div() {{ props.item.name }}
            v-chip(
              v-for="site in forSites(props.item.site_ids)"
              :color="props.item.published==1 ? site.color : 'gray'"
              :key="site.name"
              text-color="white"
              small
            ) {{site.name}}

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='news'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Дата публикации',
        align: 'left',
        value: 'published_at',
        width: '0%',
        sortable: true
      },
      {
        text: 'Заголовок',
        align: 'left',
        value: 'name',
        width: '100%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.setDataFilter({ sortBy: 'published_at', descending: true })
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setSiteId(site_id = null) {
      this.setDataFilter({ site_id })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Content.News.Edit',
        params: { id }
      })
    },

    forSites(ids) {
      if (!ids) return {}
      return ids.split(/,/).map(site_id => {
        const site = this.sitesById(site_id)
        if (!site) return {}

        return {
          color: site.color,
          name: site.name
        }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('content/news', ['fetchList', 'destroy']),
    ...mapMutations('content/news', ['setDataFilter'])
  },

  computed: {
    ...mapState('content/news', ['total', 'dataFilter']),
    ...mapGetters('content/news', ['list', 'isLoading']),
    ...mapGetters({ sitesById: 'dictionary/sites/byId' })
  }
}
</script>
